import React from 'react';
import { ListGroup } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import NavCollapse from '../NavCollapse';
import NavItem from '../NavItem';
const NavGroup = ({ layout, group }) => {
    let navItems = '';
    // const account = useSelector((state) => state.account);
    // const { user } = account;
    // const userData = user?.user;
    // // const EditUserRole = userData?.role.replace(/_/g, ' ').toUpperCase();
    // const EditUserRole = userData?.role
    //     .replace(/_/g, ' ') // Replace underscores with spaces
    //     .toLowerCase() // Convert the whole string to lowercase
    //     .replace(/(^\w{1})|(\s+\w{1})/g, (letter) => letter.toUpperCase()); // Capitalize first letter of each word

    if (group.children) {
        const groups = group.children;
        navItems = Object.keys(groups).map((item) => {
            item = groups[item];
            switch (item?.type) {
                case 'collapse':
                    return <NavCollapse key={item.id} collapse={item} type="main" />;
                case 'item':
                    return <NavItem layout={layout} key={item.id} item={item} />;
                default:
                    return false;
            }
        });
    }

    return (
        <React.Fragment>
            <div
                className="d-flex  px-4  "
                style={{
                    boxShadow: 'rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px',
                    color: 'yellow'
                    // fontWeight: 'bold'
                }}
            >
                {/* {EditUserRole} - {userData.userCode} */}
            </div>
            <ListGroup.Item as="li" bsPrefix=" " key={group.id} className="nav-item pcoded-menu-caption">
                <label>{group.title}</label>
            </ListGroup.Item>
            {navItems}
        </React.Fragment>
    );
};

export default NavGroup;
